import React from "react";
import { Reveal } from "./Reveal";
import { StarIcon } from "lucide-react";
const testimonials = [{
  name: "Mariana G.",
  flag: "🇨🇴",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/de457804-35a0-45e2-bf26-df2a27b66c17.jpg",
  quote: "Siempre soñé con crear mis propios productos, pero no sabía cómo empezar. En pocos días ya tenía mi primera colección lista para mostrar."
}, {
  name: "Laura P.",
  flag: "🇲🇽",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/f070fd38-6d11-4c73-889c-3b9fefd365c9.jpg",
  quote: "Todo está explicado paso a paso. Dejé de sentirme perdida y por fin pude hacer realidad mi idea."
}, {
  name: "Carolina R.",
  flag: "🇦🇷",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/38914bcf-7750-4be2-a07e-2265b067c229.jpg",
  quote: "Lo mejor fue ver mis primeros frascos terminados con mi propia marca. Fue una sensación increíble."
}];
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-14" data-id="element-196" data-mp="h4ddcmukdq4p">
      <div className="mx-auto max-w-xl" data-id="element-197" data-mp="m4rj1y8p0nzk">
        <Reveal className="text-center" data-id="element-198" data-mp="m6m89oqzz29g">
          <h2 className="font-serif-display text-2xl font-semibold text-[#3d2b30] sm:text-3xl" data-id="element-199" data-mp="77s7y0emud0c">
            💬 Lo que dicen quienes ya empezaron
          </h2>
          <div className="mt-3 flex items-center justify-center gap-1.5" data-id="element-200" data-mp="c7dg91fozxpq">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#e0a030] text-[#e0a030]" data-id="element-201" data-mp="zysfglc69ywr" data-mpi={i} />)}
            <span className="ml-1 text-sm font-bold text-[#3d2b30]" data-id="element-202" data-mp="14xddce3yc6i1">4.9/5</span>
            <span className="text-sm text-[#6b565b]" data-id="element-203" data-mp="q6cxho0vlabv">· +1.200 alumnas</span>
          </div>
        </Reveal>

        <div className="mt-8 space-y-4" data-id="element-204" data-mp="v3mr7fvas85i">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.06} data-id="element-205" data-mp="1itz8hhcfnh8r" data-mpi={i}>
              <figure className="rounded-2xl border border-[#f0e0e4] bg-[#fbf5f0] p-5" data-id="element-206" data-mp="1nmk1ignilqb8">
                <div className="mb-3 flex items-center gap-3" data-id="element-207" data-mp="1xhqvdh4steqb">
                  <img src={t.image} alt={`Foto de ${t.name}`} className="h-14 w-14 flex-shrink-0 rounded-full object-cover ring-2 ring-[#c98aa0]" data-id="element-208" data-mp="1xfwmj16sxd2l" />
                  <div data-id="element-209" data-mp="1ji7y5jdiznss">
                    <figcaption className="font-serif-display text-base font-semibold text-[#3d2b30]" data-id="element-210" data-mp="1jj0xw0e2hd1f">
                      {t.name} <span className="text-lg" data-id="element-211" data-mp="1ek6fv0nxbsid">{t.flag}</span>
                    </figcaption>
                    <div className="flex gap-0.5" data-id="element-212" data-mp="19rdcoh83ss8e">
                      {Array.from({
                    length: 5
                  }).map((_, s) => <StarIcon key={s} className="h-3 w-3 fill-[#e0a030] text-[#e0a030]" data-id="element-213" data-mp="14tv10j2pbywp" data-mpi={s} />)}
                    </div>
                  </div>
                </div>
                <blockquote className="text-sm leading-relaxed text-[#4d3a3f]" data-id="element-214" data-mp="vrc22a21e6fq">
                  “{t.quote}”
                </blockquote>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}